// Resolves a user's real, human-facing role

const USER_ROLE_PREFIX = 'feature:userRole:'

export const getPrimaryUserRole = (user, config) => {
  const roles = (user && user.roles) || []

  const userRole = roles.find(role => role.startsWith(USER_ROLE_PREFIX))
  if (!userRole) return 'unknown'

  // Strip the namespace prefix, then any tenant-ish prefix baked into the role.
  const baseRole = userRole
    .replace(USER_ROLE_PREFIX, '')
    .replace(/^(psm-|shelflife-|rms-|epn-)/, '')

  return baseRole
}
